<template>
    <div class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between" v-if="paginator">
        <div class="text-sm text-neutral-600 dark:text-neutral-300">
            {{ paginator.count }} {{ $pluralize('Result', paginator.count) }} | Page {{ paginator.currentPage }} of
            {{ paginator.totalPage }}
        </div>
        <div class="flex items-center justify-between gap-3 sm:justify-end">
            <label class="flex items-center text-sm text-neutral-600 dark:text-neutral-300">
                <span class="sr-only">Per Page</span>
                <select
                    :value="perPage"
                    aria-label="Per Page"
                    class="rounded border border-neutral-300 bg-transparent px-2 py-1 text-neutral-900 dark:border-neutral-500 dark:text-white"
                    @change="handlePerPageChange"
                >
                    <option
                        v-for="option in perPageOptions"
                        :key="option"
                        :value="option"
                    >
                        {{ option }}
                    </option>
                </select>
            </label>
            <div class="flex items-center justify-between">
                <Button size="sm" @click="handlePrevious">
                    <Icon icon="chevron-left"/>
                </Button>
                <Button size="sm" @click="handleNext">
                    <Icon icon="chevron-right"/>
                </Button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Paginator',
  computed: {
    hasMorePages() {
      return this.paginator.totalPage > this.paginator.currentPage;
    },
  },
  data() {
    return {};
  },
  methods: {
    handleNext() {
      if (this.hasMorePages) {
        this.$emit('next');
      }
    },
    handlePerPageChange(event) {
      this.$emit('update:perPage', Number(event.target.value));
    },
    handlePrevious() {
      if (this.paginator.currentPage > 1) {
        this.$emit('previous');
      }
    },
  },
  props: {
    paginator: {
      required: true,
    },
    perPage: {
      default: 10,
      type: Number,
    },
    perPageOptions: {
      default: () => [10, 25, 50, 100],
      type: Array,
    }
  },
}
</script>

<style scoped lang="scss">

</style>
